/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React, { useMemo } from 'react';
import Header from '../../components/header';
import { Redirect, useRouteMatch } from 'react-router-dom';
import { AppLayout } from '../../layout/AppLayout';
import { RouteInterface } from '../../types/routes';
import { AppFlavour, getDefaultConfig } from '../../config/app-config';
import { SingaporeHome } from './flavours/SingaporeHome';
import { DefaultHome } from './flavours/DefaultHome';

export const homeRouteEntry: RouteInterface = {
  id: 'home',
  label: 'Home',
  path: '/:marketplace(marketplace)?',
  exact: true,
  component: HomeRoute
}

export function HomeRoute() {
  const { params } = useRouteMatch<{ marketplace: string }>();

  const HomeComponent = useMemo(() => {
    switch (getDefaultConfig().flavour) {
      case AppFlavour.SINGAPORE:
        return SingaporeHome;
      default:
        return DefaultHome;
    }
  }, []);

  if (!params.marketplace) {
    return (
      <Redirect to='/marketplace' />
    );
  }

  return (
    <AppLayout className={'homeOverflow'} Header={
      <Header className={'responsivePage'} />
    }>
      <HomeComponent />
    </AppLayout>
  )
}

